import {
  validateEmail,
  validateNotEmpty,
  validateTelephone,
  validateInternationalTelephone,
} from '~helpers/validate';

export const clearCharacters = str => str.replace('/[^0-9]+/g', '');

export const phoneNumberSplit = phoneNumberString => {
  let phoneCode = '';
  let phoneNumber = '';
  if (phoneNumberString) {
    const phoneArray = phoneNumberString.split(' ');
    if (phoneArray.length === 1) {
      [phoneNumber] = phoneArray;
    } else if (phoneArray.length === 2) {
      [phoneCode, phoneNumber] = phoneArray;
      phoneCode = phoneCode.replace('(', '').replace(')', '');
    } else if (phoneArray.length > 2) {
      [phoneCode] = phoneArray;
      phoneNumber = phoneArray.slice(1).join('');
    }
    phoneNumber = clearCharacters(phoneNumber);
  }
  return { phoneCode, phoneNumber };
};

export const isPhoneNumberValidate = ({ phoneCode, phoneNumber }) => {
  if (phoneCode && phoneCode.length > 0) {
    return validateInternationalTelephone(phoneNumber);
  }
  return validateTelephone(phoneNumber);
};

export const phoneNumberJoin = ({ phoneCode, phoneNumber }) => {
  if (phoneCode && phoneCode.length > 0) {
    return `(${phoneCode}) ${phoneNumber}`;
  }
  return phoneNumber;
};

/**
 * @param {String} emailAddress
 * set part of email address be *
 * e.g. local-part@domain, Display section=Rounding down(length of local-part/2), local*****@domain)
 * return changed email address
 */
export const setPartEmailAddress = emailAddress => {
  if (!validateEmail(emailAddress) || !validateNotEmpty(emailAddress)) {
    return emailAddress;
  }

  let partEmailAddress = '';
  const emailName = emailAddress.slice(0, emailAddress.lastIndexOf('@'));
  const emailDomain = emailAddress.slice(emailAddress.lastIndexOf('@') + 1);
  const replaceLen = 6;

  partEmailAddress = `${emailName.slice(0, emailName.length - replaceLen)}${Array(
    replaceLen + 1,
  ).join('*')}@${emailDomain}`;
  return partEmailAddress;
};

/**
 * @param {String} phoneNumber
 * set part of phone number be *
 * *
 * e.g. Country code-Variable length 001-6264566688,
 * Display section=Country code-The first three number-Hidden section-The rest number，
 * Hidden section=Rounding up[length of (Variable length-3)/2], 001-626****688
 * *
 * return changed phone number
 */
export const setPartPhoneNumber = phoneNumberStr => {
  const phoneNumber = phoneNumberJoin(phoneNumberSplit(phoneNumberStr));
  if (!isPhoneNumberValidate(phoneNumberSplit(phoneNumber)) || !validateNotEmpty(phoneNumber)) {
    return phoneNumberStr;
  }

  let partPhoneNumber = '';
  partPhoneNumber = phoneNumber.replace('(', '').replace(')', '');
  const phoneArr = partPhoneNumber.split(' ');
  const phoneMain = phoneArr[phoneArr.length - 1];
  const replaceLen = 6;

  phoneArr[phoneArr.length - 1] = `${phoneMain.slice(0, 3)} ${Array(replaceLen + 1).join(
    '*',
  )} ${phoneMain.slice(phoneMain.length - replaceLen)}`;
  partPhoneNumber = phoneArr.join(' ');
  return partPhoneNumber;
};

export default setPartEmailAddress;
